/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import URL from 'url-parse';
import cnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Text from '@redbubble/design-system/react/Text';
import { Link } from 'react-router-dom';
import styles from './WorkAttribution.css';
import messages from './messages';
import {
  analyticsPayload,
  EXPLORE_WORK_DETAILS_LABEL
} from '../../lib/analytics';

class WorkAttribution extends Component {
  constructor(props) {
    super(props);

    this.artistShopURL = this.artistShopURL.bind(this);
    this.artistAvatar = this.artistAvatar.bind(this);
    this.artistInfo = this.artistInfo.bind(this);
  }

  renderLink({ title, location, url, onClick, className }) {
    if (location) {
      return (
        <Text type="display5" element="p" block>
          <Link
            className={className}
            to={location}
            onClick={onClick}
            rel="nofollow"
          >
            {title}
          </Link>
        </Text>
      );
    }

    return (
      <Text type="display5" element="p" block>
        <a className={className} href={url} onClick={onClick}>
          {title}
        </a>
      </Text>
    );
  }

  render() {
    const { work, showAvatar, workLocation, logEvent } = this.props;
    const workURL = new URL(work.url, true);

    const infoStyles = cnames(
      styles.info,
      showAvatar ? styles.withAvatar : styles.withoutAvatar
    );

    return (
      <div className={infoStyles}>
        {this.artistAvatar()}
        <div className={styles.iteminfo}>
          {this.renderLink({
            title: work.title,
            location: workLocation,
            url: workURL.toString(),
            onClick: () => {
              logEvent({
                analytics: analyticsPayload.workPageView(
                  EXPLORE_WORK_DETAILS_LABEL
                )
              });
            },
            className: styles.title
          })}
          {this.artistInfo()}
        </div>
      </div>
    );
  }

  artistAvatar() {
    const { work, showAvatar } = this.props;
    const { artist } = work;

    if (!artist || !showAvatar) {
      return null;
    }

    return (
      <div className={styles.avatar}>
        <a href={this.artistShopURL()}>
          <img alt={work.title} src={artist.avatar} />
        </a>
      </div>
    );
  }

  artistShopURL() {
    const { work } = this.props;
    const { artist } = work;
    if (!artist) {
      return null;
    }
    const artistShopUrl = new URL(artist.shopUrl, true);
    return artistShopUrl.toString();
  }

  artistInfo() {
    const { work, logEvent } = this.props;
    const { artist } = work;

    if (!artist) {
      return null;
    }

    return (
      <Text
        type="body2"
        element="p"
        className={styles.artist}
        block
        muted
        onClick={() => {
          logEvent({
            analytics: analyticsPayload.artistShopPageView(
              EXPLORE_WORK_DETAILS_LABEL
            )
          });
        }}
      >
        <a href={this.artistShopURL()} className={styles.link}>
          <FormattedMessage
            {...messages.ByArtist}
            values={{
              artistName: work.artistShopDisplayName
            }}
          />
        </a>
      </Text>
    );
  }
}

WorkAttribution.propTypes = {
  work: PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    artist: PropTypes.shape({
      name: PropTypes.string,
      avatar: PropTypes.string,
      shopUrl: PropTypes.string,
      portfolioUrl: PropTypes.string,
      profileUrl: PropTypes.string
    })
  }),
  showAvatar: PropTypes.bool,
  logEvent: PropTypes.func
};

WorkAttribution.defaultProps = {
  showAvatar: true,
  logEvent: () => {}
};

WorkAttribution.displayName = 'WorkAttribution';

WorkAttribution.fragment = gql`
  fragment WorkAttribution on Work {
    title
    url
    artistShopDisplayName
    artist {
      name
      shopUrl(locale: $locale)
      portfolioUrl(locale: $locale)
      profileUrl(locale: $locale)
      avatar
    }
  }
`;

export default WorkAttribution;
